import axios from 'axios'

import { servicesBaseUrl } from 'src/api/baseUrl'
import { iamClient } from 'src/lib/api-client'

export interface IAMTokenResponse {
  access_token: string
  token_type: string
  expires_in: number
  refresh_token: string
  scope: string
  company_id: string
}

interface IAMLoginArgs {
  username: string
  password: string
}

/**
 * Login via IAM OAuth2 Resource Owner Password Credentials flow.
 * Returns the access token which works for both IAM microservices and GraphQL.
 */
export const iamLogin = async ({
  username,
  password,
}: IAMLoginArgs): Promise<IAMTokenResponse> => {
  const response = await axios.post<IAMTokenResponse>(
    `${servicesBaseUrl}/iam/oauth/token`,
    new URLSearchParams({
      grant_type: 'password',
      client_id: 'frontend_web',
      username,
      password,
    }),
    {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      withCredentials: true,
    }
  )
  return response.data
}

export const iamLogout = async (): Promise<void> => {
  await iamClient.post('/oauth/logout', null, { withCredentials: true })
}

export const iamIntrospectToken = async (token: string): Promise<boolean> => {
  const response = await iamClient.post<{ active: boolean }>(
    '/oauth/introspect',
    new URLSearchParams({ token }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
  )
  return response.data.active
}
